import React, { createContext, useContext, useState, useMemo } from 'react';
import PropTypes from 'prop-types';

const ThemeContext = createContext();

export const useThemeMode = () => useContext(ThemeContext);

export const ThemeModeProvider = ({ children }) => {
    const [mode, setMode] = useState(
        () => localStorage.getItem('themeMode') || 'dark'
    );

    const toggleMode = () => {
        setMode(prev => {
            const next = prev === 'dark' ? 'light' : 'dark';
            localStorage.setItem('themeMode', next);
            return next;
        });
    };

    const value = useMemo(() => ({ mode, toggleMode }), [mode]);

    return (
        <ThemeContext.Provider value={value}>
            {children}
        </ThemeContext.Provider>
    );
};

ThemeModeProvider.propTypes = {
    children: PropTypes.node.isRequired,
};
